(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const modal = document.querySelector('[data-fv-booking-modal]');
    const form = modal ? modal.querySelector('[data-fv-booking-form]') : null;
    const error = modal ? modal.querySelector('[data-fv-booking-error]') : null;
    let activeTrigger = null;

    if (!modal || !form) return;

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    const getFocusableElements = () => Array.from(modal.querySelectorAll(focusableSelector))
      .filter((element) => element.offsetParent !== null || element === document.activeElement);

    const showError = (message) => {
      if (!error) return;

      error.textContent = message;
      error.hidden = false;
    };

    const clearError = () => {
      if (!error) return;

      error.textContent = '';
      error.hidden = true;
    };

    const setScrollLock = (isLocked) => {
      document.documentElement.classList.toggle('fv-booking-modal-is-open', isLocked);
      document.body.classList.toggle('fv-booking-modal-is-open', isLocked);
    };

    const openModal = (trigger) => {
      activeTrigger = trigger || document.activeElement;
      clearError();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      setScrollLock(true);

      window.requestAnimationFrame(() => {
        const focusableElements = getFocusableElements();
        const firstField = modal.querySelector('input, select, textarea');

        (firstField || focusableElements[0] || modal).focus();
      });
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      setScrollLock(false);

      if (activeTrigger && typeof activeTrigger.focus === 'function') {
        activeTrigger.focus();
      }

      activeTrigger = null;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(
        '[data-custom-suit-booking-trigger], .fv-custom-booking-trigger'
      );

      if (!trigger) return;

      event.preventDefault();
      openModal(trigger);
    });

    modal.addEventListener('click', (event) => {
      if (!event.target.closest('[data-fv-booking-modal-close]')) return;

      event.preventDefault();
      closeModal();
    });

    document.addEventListener('keydown', (event) => {
      if (!modal.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusableElements = getFocusableElements();
      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];

      if (!firstFocusable || !lastFocusable) {
        event.preventDefault();
        return;
      }

      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });

    form.addEventListener('input', clearError);
    form.addEventListener('change', clearError);

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!form.checkValidity()) {
        showError('Please complete the required fields.');
        form.reportValidity();

        const firstInvalid = form.querySelector(':invalid');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      const whatsappNumber = (modal.dataset.whatsappNumber || '').replace(/\D/g, '');

      if (!whatsappNumber) {
        showError('WhatsApp number is not configured.');
        return;
      }

      const formData = new FormData(form);
      const fieldValue = (name) => String(formData.get(name) || '').trim();

      const firstName = fieldValue('firstName');
      const lastName = fieldValue('lastName');
      const phone = fieldValue('phone');
      const email = fieldValue('email');
      const occasionDate = fieldValue('occasionDate');
      const appointmentTime = fieldValue('appointmentTime');
      const appointmentType = fieldValue('appointmentType');
      const people = fieldValue('people');
      const notes = fieldValue('notes');

      const messageLines = [
        'Hello Fidel Verta, I would like to book a custom suit consultation.',
        '',
        `Name: ${firstName} ${lastName}`,
        `Phone: ${phone}`
      ];

      if (email) messageLines.push(`Email: ${email}`);

      messageLines.push(
        `Occasion date: ${occasionDate}`,
        `Preferred appointment time: ${appointmentTime}`,
        `Appointment type: ${appointmentType}`
      );

      if (people) messageLines.push(`Number of people: ${people}`);
      if (notes) messageLines.push(`Additional requests: ${notes}`);

      const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(messageLines.join('\n'))}`;
      window.open(url, '_blank', 'noopener');
    });
  });
})();
